module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_sand_4-6358bd801d145ee302abe92841e606bd.png";